import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-8 sm:py-10 bg-white" data-id="element-1259">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-1260">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} data-id="element-1261">
          {/* As Seen On - Mobile Only */}
          <div className="mb-4 sm:hidden" data-id="element-1262">
            <p className="text-xs text-charcoal-light text-center mb-2 font-light tracking-wide" data-id="element-1263">
              AS SEEN ON
            </p>
            <img src="https://cdn.magicpatterns.com/uploads/hSpRuFC5repS5nRdGHPPBc/ss_seen_on.png" alt="As seen on wellness publications" className="w-full h-auto" loading="lazy" decoding="async" width="800" height="200" data-id="element-1264" />
          </div>

          <div className="flex justify-center mb-3 sm:mb-4" data-id="element-1265">
            <AlertCircle className="w-6 h-6 sm:w-8 sm:h-8 text-charcoal-light opacity-50" data-id="element-1266" />
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-charcoal mb-4 sm:mb-6 tracking-tight" data-id="element-1267">
            Why Most Creams Fail the Moment You Need Them Most
          </h2>

          <div className="space-y-3 sm:space-y-4 text-sm sm:text-base text-charcoal-light leading-relaxed font-light" data-id="element-1268">
            <p data-id="element-1269">
              Cold creams don't fix tension. They shock the skin. Overload the
              nerves. Silence sensation without relaxing what's holding tight.
            </p>
            <p className="font-normal text-charcoal" data-id="element-1270">
              So things feel better briefly… then stiffen again by evening.
            </p>
            <div className="pt-2" data-id="element-1271">
              <span className="inline-block px-4 py-2 bg-gray-100 rounded-lg text-charcoal text-xs sm:text-sm font-normal border-l-4 border-charcoal" data-id="element-1272">
                Tension isn't damage. It's sustained contraction.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}